import { render, staticRenderFns } from "./reporte_reportesemanal.vue?vue&type=template&id=52125bc2&scoped=true"
import script from "./reporte_reportesemanal.vue?vue&type=script&lang=js"
export * from "./reporte_reportesemanal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52125bc2",
  null
  
)

export default component.exports